export default "__VITE_ASSET__LlqJce8i__"